// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"124":"6724409d","895":"059fc0f8"}[chunkId] + ".css";
};